/*
 * Created Date: Tue, 15th Dec 2020, 10:51:05 am
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState, useEffect } from 'react';
import {
  TopToolbar,
  sanitizeListRestProps,
  useDataProvider,
  CreateButton,
} from 'react-admin';
import { Help } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import { useDispatch } from 'react-redux';
import getHelp from '../../utils/getHelp';

const ProjectActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);
  useMountEffect(
    getHelp('help_url_project', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

ProjectActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default ProjectActions;
